
import FindPartner from "@/components/landing/landing-free/find-partner";
import blog from "@/components/landing/blog";
import QuotesBlock from "@/components/landing/landing-free/quotes-block";
import ServiceFor from "@/components/landing/landing-free/service-for";
import HowWeDo from "@/components/landing/landing-free/how-we-do";
import SitesScan from "@/components/landing/landing-free/sites-scan";
import Waiting from "@/components/landing/landing-free/waiting";
import Results from "@/components/landing/landing-free/results";
import Steps from "@/components/landing/landing-free/steps";
import RealStories from "@/components/landing/landing-free/real-stories.vue";
import Featured from "@/components/landing/landing-free/featured";
import Mission from "@/components/landing/landing-free/mission";
import AlreadyUsing from "@/components/landing/landing-free/already-using";
import Comments from "@/components/landing/landing-free/comments";
import Overcoming from "@/components/landing/landing-free/overcoming";
import Faq from "@/components/landing/landing-free/faq";
import QuotesBlockKnowledge from "@/components/landing/landing-free/quotes-block-knowledge";
import Navigation from '@/components/Navigation.vue';
import FooterMain from '@/components/FooterMain.vue';
import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";

export default {

  layout: 'default',
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    QuotesBlock,
    ServiceFor,
    HowWeDo,
    SitesScan,
    Waiting,
    blog,
    Results,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },

  head() {
    const title = 'Free Cheater Finder | Cheater Buste & Lookup | Find Out If Your Partner Is Cheating Online';
    const description = 'Looking for a free cheater finder? Catch a cheater online quickly and anonymously. Use our trusted service to find out if your partner is cheating-just enter their email to start for free on the best cheater website!';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        {
          name: "viewport",
          content: "width=device-width, initial-scale=1"
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: "description",
          name: "description",
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'free cheater finder, catch a cheater free, free sites to catch a cheater'
        },
        {
          hid: "og:description",
          name: "og:description",
          content: description
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: '/products/find-someone-cheating-online-for-free/og.png'
        },
        {
          hid:'og:site_name',
          property: 'og:site_name',
          content: 'ifindcheaters.com'
        },
        {
          hid: 'og:keywords',
          name: 'og:keywords',
          content: 'how to find out if your spouse is cheating for free, how to find out if someone is cheating online for free, free cheater lookup, find someone on dating sites by email free, catch a cheater free'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/landing/img/iphone-pro-max.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/find-someone-cheating-online-for-free/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Free search for partner on social media and dating sites"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Free search for partner on social media and dating sites",
            "sku": "001",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": "Quick, Easy & 100% Anonymous Service to catch a disloyal partner. All you need to find a cheater online is their email. Sign up to try it for FREE!",
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/find-someone-cheating-online-for-free/",
              "priceCurrency": "USD",
              "price": "00.00",
              "priceValidUntil": "2022-05-25",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "JudiAngel82"
              },
              "datePublished": "2022-03-11T17:05:30+00:00",
              "reviewBody": "I was devastated when I saw he had active accounts but we talked it out and our relationship is better today. it's the best site to catch a cheater."
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Gwen P."
              },
            "datePublished": "2020-11-13T13:45:29+00:00",
            "reviewBody": "After my divorce I was afraid to start dating again but a friend told me about ifindcheaters as cheater finder. I was skeptical, but when I saw how easy it was to see who I was really meeting I felt a lot more confidant."
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.7",
              "reviewCount": "72"
              }
            }
          }
      ]
    }
  },
};
